<div class="public-disclosure-overlay">
  <div class="public-disclosure-container">
    <div class="header">
      <h2>Public Disclosure</h2>
      <button class="close-btn" (click)="closeModal()">✖</button>
    </div>

    <div *ngIf="isLoading" class="loading-spinner">Loading...</div>

    <div *ngIf="!isLoading && documentList.length" class="body">
      <div *ngFor="let row of documentList" class="cards">
        <h4>{{ row.heading | titlecase }}</h4>
        <div class="item" *ngFor="let item of row.items">
          <span class="item-name">{{ item.name }}</span>
          <div class="item-action">
            <a
              *ngIf="item.file"
              [href]="item.file"
              target="_blank"
              class="download-btn"
            >
              Download
            </a>
            <span *ngIf="!item.file" class="no-data">N/A</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!isLoading && !documentList.length" class="no-data">
      No documents available.
    </div>
  </div>
</div>
